type Status = {
	sValue: string | undefined
	sText: string | undefined
}

type StatusType = {
	oStatus?: Status
	oFormat?: Status
	oLiveGameStatus?: Status
	sStatusStr?: string | undefined
	sFormatStr?: string | undefined
	sLiveGameStatusStr?: string | undefined
}

export default function getStatus(data: Partial<StatusType>) {
	const sStatusStr = (data?.oStatus?.sValue || data?.sStatusStr || '')?.toLowerCase()
	const sFormatStr = (data?.oFormat?.sValue || data?.sFormatStr || '')?.toLowerCase()
	const sLiveGameStatusStr = (data?.oLiveGameStatus?.sValue || data?.sLiveGameStatusStr || '')?.toLowerCase()
	const sFormat = data?.oFormat?.sText || <span className='capitalize'>{sFormatStr}</span>
	const sStatus = data?.oStatus?.sText || <span className='capitalize'>{sStatusStr}</span>
	const sLiveGameStatus = data?.oLiveGameStatus?.sText || <span className='capitalize'>{sLiveGameStatusStr}</span>
	const conditions = {
		live: sLiveGameStatus,
	}
	return { sStatus: conditions?.[sStatusStr as 'live'] || sStatus, sStatusStr, sLiveGameStatusStr, sFormatStr, sFormat, sLiveGameStatus }
}
